import * as actions from './action';
import reducers from './reducer';

export const User = { actions, reducers };
export { UserState } from './reducer';
